import React from "react";

const WalkInClsdSvg = (props) => (
  <svg
    style={{ margin: "0px", padding: "0px", height: "90px", width: "200px" }}
  >
    <svg
      height="200px"
      width="auto"
      id="ICONS"
      version="1.1"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect
          x="2"
          y="2"
          width="105"
          height="50"
          fill="none"
          stroke={props.rectColor}
          stroke-width="1"
        ></rect>
        <text
          x="4"
          y="10"
          font-family="Verdana"
          font-size="6"
          font-weight="normal"
          fill={props.textColor}
        >
          {props.name}
        </text>
      </g>
      <g
        fill="none"
        fill-rule="evenodd"
        id="Snow"
        stroke="none"
        stroke-width="1"
      >
        <g
          id="Group"
          stroke={props.strokeColor1}
          transform="translate(7.000000, 15.000000)"
        >
          <g>
            <path
              d="M9.28571429,0.928571429 L13,3.71428571 L16.7142857,0.928571429 M25.0714286,9.28571429 L22.2857143,13 L25.0714286,16.7142857 M16.7142857,25.0714286 L13,22.2857143 L9.28571429,25.0714286 M0.928571429,16.7142857 L3.71428571,13 L0.928571429,9.28571429"
              id="Path-12"
              stroke-linecap="round"
              stroke-width="2"
            />
            <circle cx="13" cy="13" fill="#979797" id="Oval-9" r="1.85714286" />
            <path
              d="M13,0 L13,26"
              id="Path-13"
              stroke-linecap="round"
              stroke-width="2"
            />
            <path
              d="M0,13 L26,13"
              id="Path-14"
              stroke-linecap="round"
              stroke-width="2"
            />
            <path
              d="M3.71428571,3.71428571 L22.2857143,22.2857143"
              id="Path-16"
              stroke-linecap="round"
              stroke-width="2"
            />
            <path
              d="M3.71428571,22.2857143 L22.2857143,3.71428571"
              id="Path-17"
              stroke-linecap="round"
              stroke-width="2"
            />
          </g>
        </g>
      </g>
    </svg>
    <svg
      height="auto"
      version="1.1"
      viewBox="0 0 60 60"
      width="300px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title />
      <desc />
      <defs />
      <g
        fill="none"
        fill-rule="evenodd"
        id="Thermometer-Hot"
        stroke="none"
        stroke-width="1"
        transform="translate(-33,13)"
      >
        <g
          id="Group"
          stroke="#979797"
          stroke-width="2"
          transform="translate(7.000000, 2.000000)"
        >
          <path
            d="M3,16.8026932 L3,3 C3,1.34314575 4.34314575,3.04359188e-16 6,0 C7.65685425,-3.04359188e-16 9,1.34314575 9,3 L9,16.8026932 C10.7934041,17.8401214 12,19.7791529 12,22 C12,25.3137085 9.3137085,28 6,28 C2.6862915,28 0,25.3137085 0,22 C0,19.7791529 1.20659589,17.8401214 3,16.8026932 Z"
            id="Combined-Shape"
          />
          <path d="M13,5 L18,5" id="Path-19" stroke-linecap="round" />
          <path d="M13,9 L18,9" id="Path-20" stroke-linecap="round" />
          <path d="M13,13 L18,13" id="Path-21" stroke-linecap="round" />
        </g>
        <g fill="red" id="Group-2" transform="translate(10.000000, 12.000000)">
          <circle cx="3" cy="12" id="Oval" r="3" />
          <rect height="11" id="Rectangle-2" rx="1" width="2" x="2" y="0" />
        </g>
      </g>
    </svg>

    <svg
      version="1.1"
      viewBox="0 0 1700 1700"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="#979797"
        stroke-width="2"
        transform="translate(900,350)"
        fill="green"
      >
        <path d="M766.3,108.6c0,7.5,0,15,0,22.5c0,20.3,0,40.6,0,60.9c0,30,0,60,0,89.9c0,36.7,0,73.5,0,110.2     c0,40.1,0,80.1,0,120.2c0,40.5,0,80.9,0,121.4c0,37.9,0,75.8,0,113.6c0,31.9,0,63.8,0,95.6c0,23,0,46,0,69.1     c0,10.9-0.1,21.7,0,32.6c0,0.5,0,0.9,0,1.4c13.3-13.3,26.7-26.7,40-40c-19.6,0-39.3,0-58.9,0c-46.8,0-93.6,0-140.4,0     c-56.6,0-113.1,0-169.7,0c-49,0-98.1,0-147.1,0c-23.8,0-47.6-0.4-71.4,0c-0.3,0-0.7,0-1,0c13.3,13.3,26.7,26.7,40,40     c0-7.5,0-15,0-22.5c0-20.4,0-40.8,0-61.2c0-30.2,0-60.3,0-90.5c0-36.8,0-73.5,0-110.3c0-40.3,0-80.5,0-120.8     c0-40.6,0-81.2,0-121.8c0-37.8,0-75.6,0-113.4c0-31.9,0-63.7,0-95.6c0-22.8,0-45.6,0-68.4c0-10.6-0.1-21.2,0-31.8     c0-1.8,0.1-3.5,0.3-5.2c-0.5,3.5-1,7.1-1.4,10.6c0.4-2.7,1.1-5.2,2.1-7.7c-1.3,3.2-2.7,6.4-4,9.6c1.1-2.4,2.3-4.6,3.9-6.8     c-2.1,2.7-4.2,5.4-6.3,8.1c1.6-2,3.4-3.9,5.4-5.5c-2.7,2.1-5.4,4.2-8.1,6.3c2.1-1.6,4.3-2.9,6.7-4c-3.2,1.3-6.4,2.7-9.6,4     c2.5-1,5-1.7,7.6-2.1c-3.5,0.5-7.1,1-10.6,1.4c5.7-0.7,11.6-0.3,17.4-0.3c12.7,0,25.4,0,38.1,0c42.3,0,84.5,0,126.8,0     c51.3,0,102.6,0,153.8,0c44.2,0,88.4,0,132.6,0c21.1,0,42.1-0.2,63.2,0c1.6,0,3.2,0.1,4.7,0.3c-3.5-0.5-7.1-1-10.6-1.4     c2.7,0.4,5.1,1.1,7.6,2.1c-3.2-1.3-6.4-2.7-9.6-4c2.4,1.1,4.6,2.4,6.7,4c-2.7-2.1-5.4-4.2-8.1-6.3c2,1.7,3.8,3.5,5.4,5.5     c-2.1-2.7-4.2-5.4-6.3-8.1c1.6,2.1,2.8,4.3,3.9,6.8c-1.3-3.2-2.7-6.4-4-9.6c1,2.5,1.7,5,2.1,7.7c-0.5-3.5-1-7.1-1.4-10.6     C766.1,105.8,766.2,107.2,766.3,108.6c0.2,10.4,4.3,20.9,11.7,28.3c6.9,6.9,18.3,12.2,28.3,11.7c21.3-1,40.5-17.6,40-40     c-0.9-38.7-31.4-69.8-70.3-70.5c-3,0-6,0-8.9,0c-17,0-33.9,0-50.9,0c-27.5,0-54.9,0-82.4,0c-33.2,0-66.5,0-99.7,0     c-34.4,0-68.8,0-103.2,0c-30.5,0-60.9,0-91.4,0c-21.9,0-43.8,0-65.7,0c-8.6,0-17.2-0.2-25.8,0c-38.8,0.7-69.4,31.9-70.1,70.6     c0,1.8,0,3.7,0,5.5c0,11.3,0,22.6,0,33.9c0,19.7,0,39.4,0,59.1c0,26.3,0,52.5,0,78.8c0,31.1,0,62.2,0,93.3c0,33.7,0,67.4,0,101.1     c0,34.6,0,69.1,0,103.7c0,33.7,0,67.3,0,101c0,30.6,0,61.1,0,91.7c0,25.7,0,51.4,0,77.2c0,19.1,0,38.1,0,57.2     c0,10.3,0,20.6,0,30.9c0,1.3,0,2.6,0,3.9c0,21.6,18.3,40,40,40c19.6,0,39.3,0,58.9,0c46.8,0,93.6,0,140.4,0     c56.6,0,113.1,0,169.7,0c49,0,98.1,0,147.1,0c23.8,0,47.6,0.3,71.4,0c0.3,0,0.7,0,1,0c21.6,0,40-18.3,40-40c0-7.5,0-15,0-22.5     c0-20.3,0-40.6,0-60.9c0-30,0-60,0-89.9c0-36.7,0-73.5,0-110.2c0-40.1,0-80.1,0-120.2c0-40.5,0-80.9,0-121.4     c0-37.9,0-75.8,0-113.6c0-31.9,0-63.8,0-95.6c0-23,0-46,0-69.1c0-10.9,0.1-21.7,0-32.6c0-0.5,0-0.9,0-1.4c0-20.9-18.4-41-40-40     C784.6,69.5,766.3,86.1,766.3,108.6z" />
        <path d="M96.4,985.9c7.4,0,14.9,0,22.3,0c20.1,0,40.3,0,60.4,0c29.7,0,59.5,0,89.2,0c36.4,0,72.9,0,109.3,0     c39.9,0,79.9,0,119.8,0c40.1,0,80.3,0,120.4,0c37.4,0,74.9,0,112.3,0c31.8,0,63.5,0,95.3,0c22.7,0,45.5,0,68.2,0     c10.8,0,21.6,0.1,32.4,0c0.5,0,0.9,0,1.4,0c20.9,0,41-18.4,40-40c-1-21.7-17.6-40-40-40c-7.4,0-14.9,0-22.3,0     c-20.1,0-40.3,0-60.4,0c-29.7,0-59.5,0-89.2,0c-36.4,0-72.9,0-109.3,0c-39.9,0-79.9,0-119.8,0c-40.1,0-80.3,0-120.4,0     c-37.4,0-74.9,0-112.3,0c-31.8,0-63.5,0-95.3,0c-22.7,0-45.5,0-68.2,0c-10.8,0-21.6-0.1-32.4,0c-0.5,0-0.9,0-1.4,0     c-20.9,0-41,18.4-40,40C57.4,967.6,74,985.9,96.4,985.9L96.4,985.9z" />
        <path d="M582.3,512c0.5,16.1,6.3,32.2,18.2,43.4c11.5,10.9,26.5,17.3,42.5,17.3c33,0,60.7-27.7,60.7-60.7     c0-33-27.7-60.7-60.7-60.7c-16,0-30.9,6.5-42.5,17.3C588.6,479.8,582.8,495.9,582.3,512c-0.7,20.9,18.9,40.9,40,40     c22.3-1,39.3-17.6,40-40c0-0.9,0.1-1.8,0.2-2.7c-0.5,3.5-1,7.1-1.4,10.6c0.3-1.8,0.7-3.4,1.3-5.1c-1.3,3.2-2.7,6.4-4,9.6     c0.7-1.6,1.5-3,2.5-4.5c-2.1,2.7-4.2,5.4-6.3,8.1c1.3-1.7,2.8-3.2,4.5-4.5c-2.7,2.1-5.4,4.2-8.1,6.3c1.4-1,2.9-1.8,4.5-2.5     c-3.2,1.3-6.4,2.7-9.6,4c1.7-0.6,3.3-1,5.1-1.3c-3.5,0.5-7.1,1-10.6,1.4c1.8-0.2,3.6-0.2,5.4,0c-3.5-0.5-7.1-1-10.6-1.4     c1.8,0.3,3.4,0.7,5.1,1.3c-3.2-1.3-6.4-2.7-9.6-4c1.6,0.7,3,1.5,4.5,2.5c-2.7-2.1-5.4-4.2-8.1-6.3c1.7,1.3,3.2,2.8,4.5,4.5     c-2.1-2.7-4.2-5.4-6.3-8.1c1,1.4,1.8,2.9,2.5,4.5c-1.3-3.2-2.7-6.4-4-9.6c0.6,1.7,1,3.3,1.3,5.1c-0.5-3.5-1-7.1-1.4-10.6     c0.2,1.8,0.2,3.6,0,5.4c0.5-3.5,1-7.1,1.4-10.6c-0.3,1.8-0.7,3.4-1.3,5.1c1.3-3.2,2.7-6.4,4-9.6c-0.7,1.6-1.5,3-2.5,4.5     c2.1-2.7,4.2-5.4,6.3-8.1c-1.3,1.7-2.8,3.2-4.5,4.5c2.7-2.1,5.4-4.2,8.1-6.3c-1.4,1-2.9,1.8-4.5,2.5c3.2-1.3,6.4-2.7,9.6-4     c-1.7,0.6-3.3,1-5.1,1.3c3.5-0.5,7.1-1,10.6-1.4c-1.8,0.2-3.6,0.2-5.4,0c3.5,0.5,7.1,1,10.6,1.4c-1.8-0.3-3.4-0.7-5.1-1.3     c3.2,1.3,6.4,2.7,9.6,4c-1.6-0.7-3-1.5-4.5-2.5c2.7,2.1,5.4,4.2,8.1,6.3c-1.7-1.3-3.2-2.8-4.5-4.5c2.1,2.7,4.2,5.4,6.3,8.1     c-1-1.4-1.8-2.9-2.5-4.5c1.3,3.2,2.7,6.4,4,9.6c-0.6-1.7-1-3.3-1.3-5.1c0.5,3.5,1,7.1,1.4,10.6c-0.1-0.9-0.2-1.8-0.2-2.7     c-0.3-10.5-4.2-20.8-11.7-28.3c-6.9-6.9-18.3-12.2-28.3-11.7C601.2,472.9,581.6,489.6,582.3,512z" />
      </g>
    </svg>
  </svg>
);
export default WalkInClsdSvg;
